import { ITableHeader } from "@dotlegal/dotlegal-ui-components";
import { DataControllerRecordModel } from "./DataControllerRecord.types";

// The column order of the record. DataControllerRecordCells renders its cells in the same order.
export function getDataControllerRecordHeaders(isExtended: boolean, translateString: (key: string) => string): Array<ITableHeader<DataControllerRecordModel>> {
    const headers: Array<ITableHeader<DataControllerRecordModel>> = [{ property: "name", text: translateString("processingActivity"), align: "left" }];

    if (isExtended) {
        headers.push({ property: "businessAreas", text: translateString("businessAreas"), align: "left" });
        headers.push({ property: "description", text: translateString("description"), align: "left" });
    }

    headers.push({ property: "purposes", text: translateString("purposes"), align: "left" });
    headers.push({ property: "dataCategories", text: translateString("dataCategoryHeader"), align: "left" });

    if (isExtended) {
        headers.push({ property: "legalBases", text: translateString("legalBasisDataProcessorRecord"), align: "left" });
        headers.push({ property: "disclosureBases", text: translateString("basisOfDisclosures"), align: "left" });
    }

    headers.push({ property: "dataSubjects", text: translateString("dataSubjects"), align: "left" });
    headers.push({ property: "deletionPeriods", text: translateString("deletionPeriods"), align: "left" });
    headers.push({ property: "securityMeasures", text: translateString("securityMeasures"), align: "left" });

    if (isExtended) {
        headers.push({ property: "systems", text: translateString("systems"), align: "left" });
    }

    headers.push({ property: "recipientsEuEea", text: translateString("recipientsEuEaa"), align: "left" });
    headers.push({ property: "recipientsAdequate", text: translateString("recipientsAdequate"), align: "left" });
    headers.push({ property: "recipientsThirdCountry", text: translateString("recipientsThirdCountry"), align: "left" });

    if (isExtended) {
        headers.push({ property: "transferBases", text: translateString("transferBasis"), align: "left" });
    }

    return headers;
}
